import { useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { Confluence } from '../interfaces';
import { hideConfluenceArticle, showConfluenceArticle } from '../api';

function useShowOrHideArticle(
  article: Confluence.IArticle | null,
  onShowOrHide?: (article: Confluence.IArticle) => void,
) {
  const { enqueueSnackbar } = useSnackbar();

  const [{ error, loading }, setArticle] = useState<{
    loading: boolean;
    error: string | null;
  }>({ loading: false, error: null });

  async function handleShowOrHideArticle() {
    if (!article?.id) return;

    try {
      setArticle((prevState) => ({ ...prevState, loading: true }));

      await (article?.hide ? showConfluenceArticle : hideConfluenceArticle)(article.id);

      if (onShowOrHide) onShowOrHide(article);
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      enqueueSnackbar(message, { variant: 'error' });
      setArticle((prevState) => ({ ...prevState, error: message }));
    } finally {
      setArticle((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { error, loading, handleShowOrHideArticle };
}

export default useShowOrHideArticle;
